import { CommonModule, CurrencyPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '@brunsker/environments/environment';
import { DEFAULT_PIPES_PROVIDERS } from '@brunsker/libs/core/features/generic-pipe/src';
import { CoreUtilsBrazilianCurrencyModule } from '@brunsker/libs/core/utils/brazilian-currency';
import { ENVIRONMENT_TOKEN, HandleErrorInterceptor, LogInterceptor } from '@brunsker/libs/core/utils/http-log-interceptor/src';
import { LoadingInterceptor, PortalDoVendedorUtilsBaseApiModule } from '@brunsker/libs/portal-do-vendedor/utils/base-api';
import { ValidStyleModule } from '@brunsker/libs/portal-do-vendedor/utils/valid-style';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { JwtInterceptor } from '@brunsker/libs/core/utils/base-api';

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CoreUtilsBrazilianCurrencyModule,
    PortalDoVendedorUtilsBaseApiModule,
    ValidStyleModule,
    MatSnackBarModule,
    BrowserModule,
    MatDialogModule
  ],
  providers: [
    MatSnackBar,
    DEFAULT_PIPES_PROVIDERS,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HandleErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LogInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: ENVIRONMENT_TOKEN,
      useValue: environment,
    },
    CurrencyPipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  static injector: Injector;

  constructor(injector: Injector) {
    AppModule.injector = injector;
  }
}
